import { KanbanAggregations } from "./types";
import { DealData } from "@/pages/deals/types";
import React, { createContext, useState, ReactNode } from "react";

interface KanbanContextProps {
  deals: DealData[];
  setDeals: React.Dispatch<React.SetStateAction<DealData[]>>;
  columnRefetchFunctions: Record<number, () => void>;
  setColumnRefetchFunctions: React.Dispatch<
    React.SetStateAction<Record<number, () => void>>
  >;
  columnAggregations: KanbanAggregations;
  setColumnAggregations: React.Dispatch<
    React.SetStateAction<KanbanAggregations>
  >;
}

export const KanbanContext = createContext<KanbanContextProps | undefined>(
  undefined
);

interface KanbanProviderProps {
  children: ReactNode;
}

export const KanbanProvider: React.FC<KanbanProviderProps> = ({ children }) => {
  const [deals, setDeals] = useState<DealData[]>([]);
  const [columnRefetchFunctions, setColumnRefetchFunctions] = useState<
    Record<number, () => void>
  >({});
  const [columnAggregations, setColumnAggregations] =
    useState<KanbanAggregations>({});

  return (
    <KanbanContext.Provider
      value={{
        deals,
        setDeals,
        columnRefetchFunctions,
        setColumnRefetchFunctions,
        columnAggregations,
        setColumnAggregations
      }}
    >
      {children}
    </KanbanContext.Provider>
  );
};
